import React from 'react';
import './loader.css';

const LoadingScreen = () => {
    return (
        <div className="loading-screen">
            <div className="spinner"></div>
            <p>Loading page, please wait...</p>
        </div>
    );
};

export default LoadingScreen;
